import React from 'react';
import StyledTabs from "./Tabs.styled";
import StyledCard from "../Common/Card.styled";

// import {FaCogs, FaGraduationCap} from "react-icons/fa";
import StyledExperienceContentGrid from "./ExperienceContentGrid.styled";
import DigitalTransformationImg from "../../images/DigitalTransformation-Web.png";
import ITSupport from "../../images/IT Support.png";
import WI_StatuteTOC from "../../images/WI-statute-TOC.png";
import ExtractTransformLoad from "../../images/ExtractTransformLoad.png";
import UW_Stout from "../../images/UW-Stout_20190622_152336.jpg";
import University_StThomas from "../../images/University-of-StThomas_DSC5602.jpg"
import DigitalTransformationModalButton from "./Buttons/DigitalTransformationModalButton";
import ITSupportModalButton from "./Buttons/ITSupportModalButton";
import ContentDatabaseManagementModalButton from "./Buttons/ContentDatabaseManagementModalButton";
import AppDevSupportModalButton from "./Buttons/AppDevSupportModalButton";
import StyledImageFluid from "./Image.styled";
import {Color} from "../Common/Colors";
// import {CSSTransition} from "react-transition-group";

const Tabs = () => {
    const [currentTab, setCurrentTab] = React.useState(1);

    return (
        <StyledTabs>
            {/* Nav tabs */}
            <div className="tab_menu">
                <ul className="tab_list">
                    <li>
                        <button className={`tab_button ${currentTab === 1 ? 'active' : ''} tab-font-size`}
                                onClick={() => setCurrentTab(1)} type="button" role="tab">
                            <span className="tab_icon fa-solid fa-user-gear"/>
                            <span className="tab_label">Experience</span>
                        </button>
                    </li>
                    <li>
                        <button className={`tab_button ${currentTab === 2 ? 'active' : ''} tab-font-size`}
                                onClick={() => setCurrentTab(2)} type="button" role="tab">
                            <span className="tab_icon fa-solid fa-graduation-cap"/>
                            <span className="tab_label">Education</span>
                        </button>
                    </li>
                </ul>
            </div>

            {/* Tab panes with CSS Grid */}
            <div className="tab_content">

                {/*<CSSTransition in={currentTab === 1} timeout={{exit: 1000, enter: 3000}} classNames='slideIn'>*/}
                <>
                    {currentTab === 1 &&
                        <div id="experience" className={`tab_pane`}>
                            <StyledExperienceContentGrid>
                                <StyledCard>
                                    <StyledImageFluid src={DigitalTransformationImg} alt="Digital Transformation"
                                                      backgroundColor={Color.lightskyblue}
                                                      borderTopRadius></StyledImageFluid>
                                    <div className="card_body">
                                        <h4 className="card_title"><strong>Process
                                            Improvement &amp; Reengineering</strong>
                                        </h4>
                                        <p><b>Digital transformation</b> experience migrating
                                            and modernizing legacy systems, software, and data.</p>

                                        {/* Button to Open the Modal */}
                                        <DigitalTransformationModalButton styleBackgroundColor={"lightSkyBlue"}/>
                                    </div>
                                </StyledCard>
                                <StyledCard>
                                    <StyledImageFluid src={ITSupport} alt="IT Support" backgroundColor={Color.warning}
                                                      borderTopRadius/>
                                    <div className="card_body">
                                        <h4 className="card_title"><strong>Customer Service &amp; Incident
                                            Tracking</strong>
                                        </h4>
                                        <p><b>Customer Service</b> experience troubleshooting
                                            and resolving end user system and application issues.</p>

                                        {/* Button to Open the Modal */}
                                        <ITSupportModalButton/>
                                    </div>
                                </StyledCard>
                                <StyledCard>
                                    <StyledImageFluid src={WI_StatuteTOC} alt="WI Statutory TOC" borderTopRadius
                                                      borderBottomPlatinum/>
                                    <div className="card_body">
                                        <h4 className="card_title"><strong>Content &amp; Database
                                            Management</strong>
                                        </h4>
                                        <p><b>Software and data engineering</b> experience in
                                            the legal content and publishing industry providing document management and
                                            editorial capabilities to internal users processing statutory and regulatory
                                            material.</p>

                                        {/* Button to Open the Modal */}
                                        <ContentDatabaseManagementModalButton/>
                                    </div>
                                </StyledCard>
                                <StyledCard>
                                    <StyledImageFluid src={ExtractTransformLoad} alt="Extract Transform Load"
                                                      backgroundColor={Color.lightyellow} borderTopRadius/>
                                    <div className="card_body">
                                        <h4 className="card_title"><strong>Application
                                            Development &amp; Support</strong>
                                        </h4>
                                        <p><b>Extract Transform and Load(ETL)</b> experience with
                                            data capture and extraction processes, transforming content for value add
                                            via data pipelines, and loading content into global data repositories
                                            accessed by external applications.
                                        </p>

                                        {/* Button to Open the Modal */}
                                        <AppDevSupportModalButton/>
                                    </div>
                                </StyledCard>
                            </StyledExperienceContentGrid>
                        </div>
                    }
                </>
                {/*</CSSTransition>*/}
                {/*<CSSTransition in={currentTab === 2} timeout={{exit: 1000, enter: 300}} classNames='slideIn'>*/}
                <>
                    {currentTab === 2 &&
                        <div id="education" className={`tab_pane`}>
                            <StyledExperienceContentGrid>
                                <StyledCard>
                                    <div className="card_body">
                                        <h4 className="card_title">Bachelors of Science</h4>
                                        <h5 className="card-subtitle">Applied Mathematics and Computer Science</h5>
                                        <p>University of Wisconsin-Stout<br/>
                                            Menomonie, WI 54751</p>
                                        <StyledImageFluid src={UW_Stout} alt="UW-Stout Campus"/>
                                    </div>
                                </StyledCard>
                                <StyledCard>
                                    <div className="card_body">
                                        <h4 className="card_title"> Masters of Business Administration </h4>
                                        <h5 className="card-subtitle">Management Information Systems</h5>
                                        <p>University of St. Thomas<br/>
                                            St. Paul, MN 55105</p>
                                        <StyledImageFluid src={University_StThomas} alt="St. Thomas University Campus"/>
                                    </div>
                                </StyledCard>
                            </StyledExperienceContentGrid>
                        </div>
                    }
                </>
                {/*</CSSTransition>*/}

            </div>
        </StyledTabs>
    )
}

export default Tabs;